export default __webpack_public_path__ + "static/media/image_captioning.56cdfcd8.png";